"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createHashHistory_1 = require("history/createHashHistory");
var Routing = (function () {
    function Routing() {
    }
    Routing.prototype.initialize = function (routes) {
        var _this = this;
        var $this = this;
        if (routes) {
            return new Promise(function (resolve) {
                $this._history = createHashHistory_1.default({
                    hashType: 'noslash'
                });
                $this._history.listen(function (location, action) {
                    var route = _this._parseRoute(location);
                    $this._handle(route);
                });
                var defaultHandler = null;
                var defaultHandlerPath = null;
                $this._routes = routes;
                for (var key in routes) {
                    var route_1 = routes[key];
                    if (route_1.default) {
                        defaultHandler = route_1;
                        defaultHandlerPath = defaultHandlerPath;
                        break;
                    }
                }
                var route = $this._parseRoute($this._history.location);
                var handler = _this._routes[route.path];
                if (route) {
                    _this._currentRoute = route;
                }
                else if (defaultHandler) {
                    var locaiton = new Location();
                    locaiton.pathname = defaultHandlerPath;
                    _this._currentRoute = $this._parseRoute(location);
                }
                resolve();
            });
        }
        else {
            return Promise.resolve();
        }
    };
    Routing.prototype._handle = function (route) {
        var handler = this._routes[route.path];
        if (handler) {
            if (this._currentRoute && this._currentRoute.path !== route.path) {
                var lastHandler = this._routes[this._currentRoute.path];
                if (lastHandler && lastHandler.unload) {
                    lastHandler.unload();
                }
            }
            this._currentRoute = route;
            return handler.load(route.options);
        }
    };
    Routing.prototype._parseRoute = function (location) {
        var $this = this;
        var loader = function (route) {
            var result = $this._handle(route);
            if (result) {
                return result;
            }
            else {
                return new Promise(function (resolve) {
                    resolve();
                });
            }
        };
        var context = new Route(loader);
        context.path = location.pathname.indexOf('/') == 0 ? location.pathname.substring(1) : '/' + location.pathname;
        var options = null;
        if (location.search) {
            options = {};
            var vars = location.search.substring(1).split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                options[pair[0]] = decodeURIComponent(pair[1]);
            }
        }
        context.options = options;
        return context;
    };
    Object.defineProperty(Routing.prototype, "current", {
        get: function () {
            return this._currentRoute;
        },
        enumerable: true,
        configurable: true
    });
    Routing.prototype.load = function (hash, options) {
        var state = null;
        if (options) {
            state = '?';
            for (var key in options) {
                if (state.length > 1)
                    state += '&';
                state += key + "=" + encodeURIComponent(options[key]);
            }
        }
        this._history.push({ pathname: hash, search: state });
    };
    Routing.prototype.back = function () {
        this._history.goBack();
    };
    return Routing;
}());
exports.Routing = Routing;
var RouteHandler = (function () {
    function RouteHandler() {
    }
    return RouteHandler;
}());
exports.RouteHandler = RouteHandler;
var Route = (function () {
    function Route(loader) {
        this._loader = loader;
    }
    Route.prototype.load = function (options) {
        options = options || this.options;
        return this._loader(this);
    };
    return Route;
}());
exports.Route = Route;



//////////////////
// WEBPACK FOOTER
// ./src/Routing/index.ts
// module id = 214
// module chunks = 0